import { getDefaultDisplayMode } from "../../../components-ui/resizable-sidebar";
import { IDongBoHocPhiRequest } from "../../../model/request/dong-bo/IDongBoHocPhiRequest";
import { IDongBoHocPhiSinhVien } from "../../../model/respone/dong-bo/IDongBoHocPhiSinhVien";
import { IDongBoHocPhiActionTypes } from "../../action-types/dong-bo/IDongBoHocPhiAction";
import { IdongBoHocPhiReducer } from "../../reducer-model/dong-bo/IDongBoHocPhiReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: IdongBoHocPhiReducer = {
  sinhViens: [],
  status: eReducerStatusBase.is_not_initialization,
  idSelections: [],
  displayMode: getDefaultDisplayMode(),
  idSvViewLopTinChi: "",
  request: {
    hoc_ky: 0,
    nam_hoc: "",
    id_lops: [],
    id_svs: [],
  } as IDongBoHocPhiRequest,
} as IdongBoHocPhiReducer;

export const dongBoHocPhiReducer = (
  state: IdongBoHocPhiReducer = iniState,
  action: IDongBoHocPhiActionTypes,
): IdongBoHocPhiReducer => {
  switch (action.type) {
    case "DONG_BO_HOC_PHI_LOAD_START":
      return {
        ...state,
        sinhViens: [] as IDongBoHocPhiSinhVien[],
        status: eReducerStatusBase.is_loading,
      };
    case "DONG_BO_HOC_PHI_LOAD_SUCCESS":
      return {
        ...state,
        sinhViens: action.payload,
        status: eReducerStatusBase.is_completed,
      };
    case "DONG_BO_HOC_PHI_LOAD_ERRR":
      return {
        ...state,
        sinhViens: [] as IDongBoHocPhiSinhVien[],
        status: eReducerStatusBase.is_completed,
      };
    case "DONG_BO_HOC_PHI_CHANGE_DISPLAY_MODE":
      return {
        ...state,
        displayMode: action.payload,
      };
    case "DONG_BO_HOC_PHI_CHANGE_FOCUS_TREEVIEW_VALUE":
      return {
        ...state,
        focusedValue: action.payload,
        focusedCell: undefined,
        idSelections: [],
      };
    case "DONG_BO_HOC_PHI_SHOW_HIDE_VIEW_LOP_TIN_CHI":
      return {
        ...state,
        idSvViewLopTinChi: action.payload,
      };
    case "DONG_BO_HOC_PHI_SYNC_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
        processId: action.payload.process_id,
        isShowProcessing: true,
      };
    case "DONG_BO_HOC_PHI_SYNC_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        idSelections: [],
      };
    case "DONG_BO_HOC_PHI_SYNC_ERR":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "DONG_BO_HOC_PHI_CLOSE_PROCESSING_MODAL":
      return {
        ...state,
        isShowProcessing: false,
      };

    case "DONG_BO_HOC_PHI_CHANGE_REQUEST":
      return {
        ...state,
        request: {
          ...state.request,
          ...action.payload,
        },
        status: eReducerStatusBase.is_need_reload,
      };
    case "DONG_BO_HOC_PHI_CHANGE_SINHVIEN_SELECTED_IDS":
      return {
        ...state,
        idSelections: action.payload,
      };

    default:
      return state;
  }
};
